"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const industries = [{
  title: "Home Services",
  description: "HVAC, Plumbing & Electrical",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/home_services_hvac.png",
  link: "/IndustriesPage"
}, {
  title: "Professional Services",
  description: "Legal, Consulting & Agencies",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/professional_services_legal.png",
  link: "/IndustriesPage"
}, {
  title: "Real Estate",
  description: "Agencies & Property Management",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/real_estate_modern_home.png",
  link: "/IndustriesPage"
}, {
  title: "Healthcare",
  description: "Clinics, Dental & Medical Practices",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/healthcare_medical_clinic.png",
  link: "/IndustriesPage"
}, {
  title: "Financial Services",
  description: "Banking, Insurance & Wealth",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/financial_services_banking.png",
  link: "/IndustriesPage"
}, {
  title: "Retail & E-commerce",
  description: "Online Stores & Support",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/ecommerce_retail_shopping.png",
  link: "/IndustriesPage"
}];
export default function SectorApplications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="sector-applications" ref={ref} className={`py-24 bg-background transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-12 md:mb-16 max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Transforming Industries with AI Voice
          </h2>
          <p className="text-xl text-muted-foreground font-light">
            Discover how MollyCall.ai automates communication across diverse
            sectors, ensuring every call is answered and every opportunity is
            captured.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {industries.map((industry, index) => <CarouselItem key={index} data-index={index} className="pl-4 md:basis-1/2 lg:basis-1/3 h-[500px]">
                <div className="group relative h-full w-full overflow-hidden rounded-xl bg-muted">
                  {}
                  <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{
                backgroundImage: `url(${industry.image})`
              }} />

                  {}
                  <div className="absolute inset-0 bg-black/60 transition-colors duration-500 group-hover:bg-black/20" />

                  {}
                  <div className="absolute inset-0 flex flex-col justify-end p-8">
                    <div className="transform transition-transform duration-500 group-hover:-translate-y-2">
                      <h3 className="text-3xl font-bold text-white mb-2">
                        {industry.title}
                      </h3>
                      <p className="text-gray-200 text-lg font-medium opacity-90 mb-6">
                        {industry.description}
                      </p>

                      {}
                      <div className="opacity-0 translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                        <Button asChild className="bg-white text-black hover:bg-white/90 border-none font-semibold">
                          <Link to={industry.link}>
                            View Use Case
                            <ArrowRight className="ml-2 h-4 w-4" />
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <div className="flex justify-end gap-2 mt-8 pr-4">
            <CarouselPrevious className="static translate-y-0 translate-x-0 hover:bg-primary hover:text-white border-primary/20" />
            <CarouselNext className="static translate-y-0 translate-x-0 hover:bg-primary hover:text-white border-primary/20" />
          </div>
        </Carousel>
      </div>
    </section>;
}